(() => {
	angular.module('main').directive('editContractModal', editContractModal);

	editContractModal.$inject = [];

	function editContractModal() {
		return {
			restrict: 'E',
			scope: {
				closeEditContract: '&',
				editableContract: '=',
				saveEditedContract: '&',
				isEditContractModalSpinnningWheelActive: '='
			},
			template: ` <section class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <form role="form">
                                        <div class="modal-header">
                                            <btn-close ng-click="closeEditContract()"></btn-close>
                                            <h3 class="modal-title">Edit Contract</h3>
                                        </div>

                                        <div class="modal-body">
                                            <div class="field-info">
                                               <h4 class="mt-0">Contract terms and conditions</h4>
                                                <sn-quill-editor-web
                                                    [editor-i-d]="'editable_contract_text'"
                                                    [init-value]="editableContract.text"
                                                    [toolbar-settings]="'variables color size font'"
                                                    [vars-list]="'CONTRACT_MENU'"
                                                    (on-text-change)="editableContract.text = $event">
                                                </sn-quill-editor-web>
                                            </div>
                                        </div>
                                        <div class="modal-footer modal-foot">
                                            <button type="submit" ng-click="saveEditedContract()" class="btn btn-success btn-lg" spinning-wheel is-spinning-wheel-active="isEditContractModalSpinnningWheelActive">Save contract</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
`,
			replace: true,
			transclude: true,
			link(scope) {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/editContractModal.js